import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { XmlUtilService } from './xml-util.service';

@Injectable({ providedIn: 'root' })
export class SoapService {
  // This method is used to initialize the class instance using http and xml
  constructor(
    private http: HttpClient,
    private xml: XmlUtilService
  ) {}

  /**
   * POST a SOAP envelope and return typed JSON.
   * @param url  Full endpoint URL
   * @param envelope Raw XML envelope
   * @param soapAction Optional SOAPAction header
   */
  // This method is used to call using url, envelope, and soap action
  async call<T>(
    url: string,
    envelope: string,
    soapAction = ''
  ): Promise<T> {
    // Extra header only if needed (interceptor sets defaults)
    const hdrs = soapAction ? new HttpHeaders({ SOAPAction: soapAction }) : undefined;

    const rawXml = await firstValueFrom(
      this.http.post(url, envelope, { responseType: 'text', headers: hdrs })
    );

    return this.xml.xmlToJson<T>(rawXml);
  }
}
